import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bde143e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde143e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bde143e')) {
      api.createRecord('6bde143e', component.options)
    } else {
      api.reload('6bde143e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bde143e&scoped=true&", function () {
      api.rerender('6bde143e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/address/components/form/index.vue"
export default component.exports